import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'mprd-download-desktop',
  templateUrl: './download-desktop.component.html',
  styleUrls: ['./download-desktop.component.css'],
})
export class DownloadDesktopComponent {
  @Output() toggleView: EventEmitter<void> = new EventEmitter();

  constructor() {}

  public click() {
    this.toggleView.emit();
  }
}
